import {TodoSection} from "@models/todo_section.model.ts";

export class TodoList {
  id: number;
  name: string;
  sections: TodoSection[];

  constructor() {

    this.id = -1;
    this.name = "";
    this.sections = [];

  }
}
